import {adminAxios} from '@/Plugins/Axios';

/**
 * admin › ຂໍ້ມູນລູກຄ້າ › ລູກຄ້າບໍ່ໄດ້ໃຊ້ແອັບ — app customers not active within N days.
 * BFF: api/admin/customers/inactive (list, provinces, exports request/list/download).
 */
const ROOT = 'customers/inactive';

const clean = (params = {}) => Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
);

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : res.data);

export async function fetchInactiveCustomers(params = {}) {
    const res = await adminAxios.get(ROOT, {params: clean(params)});
    return unwrap(res);
}

export async function fetchProvinces() {
    const res = await adminAxios.get(`${ROOT}/provinces`);
    const data = unwrap(res);
    return Array.isArray(data) ? data : [];
}

/** Queue an async export with the same filter as the list. Returns { file_id, name, status, filter }. */
export async function requestExport(body = {}) {
    const res = await adminAxios.post(`${ROOT}/exports`, clean(body));
    return unwrap(res);
}

/** The caller's own export files, newest first. Returns { exports, pagination }. */
export async function listExports(params = {}) {
    const res = await adminAxios.get(`${ROOT}/exports`, {params: clean(params)});
    return unwrap(res);
}

/**
 * Download a finished export. While the file is still processing the BFF answers with JSON instead of a
 * blob, so the caller can keep polling.
 * @returns {{ready: true}} after triggering the browser download, or {ready: false, status} while pending.
 */
export async function downloadExport(id) {
    const res = await adminAxios.get(`${ROOT}/exports/${id}/download`, {responseType: 'blob'});

    const type = res.headers['content-type'] || '';
    if (type.includes('application/json')) {
        let status = 'processing';
        try {
            status = JSON.parse(await res.data.text())?.data?.status || status;
        } catch (e) { /* keep default */ }
        return {ready: false, status};
    }

    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filenameFrom(res.headers['content-disposition'], `inactive-customers-${id}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return {ready: true};
}

function filenameFrom(contentDisposition, fallback) {
    if (!contentDisposition) return fallback;
    const utf8 = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i);
    if (utf8) {
        try {
            return decodeURIComponent(utf8[1].trim());
        } catch (e) {
            return utf8[1].trim();
        }
    }
    const plain = contentDisposition.match(/filename="?([^";]+)"?/i);
    return plain ? plain[1].trim() : fallback;
}

export function errorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    if (data && data.errors) {
        const first = Object.values(data.errors).flat()[0];
        if (first) return first;
    }
    return (data && data.message) || fallback;
}
